"use strict";
var $ = require("../internals/export");
var uncurryThis = require("../internals/function-uncurry-this");
var requireObjectCoercible = require("../internals/require-object-coercible");
var toString = require("../internals/to-string");
var charCodeAt = uncurryThis("".charCodeAt);
$({ target: "String", proto: true }, {
  isWellFormed: function isWellFormed() {
    var S = toString(requireObjectCoercible(this));
    var length = S.length;
    for (var i = 0; i < length; i++) {
      var charCode = charCodeAt(S, i);
      if ((charCode & 63488) !== 55296) continue;
      if (charCode >= 56320 || ++i >= length || (charCodeAt(S, i) & 64512) !== 56320) return false;
    }
    return true;
  }
});
